// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { FC, useState } from 'react';
import { AuthenticationFragment, AuthenticationLinkFragment } from 'graphql/__generated__/types';
import { UitkPrimaryButton, UitkSecondaryButton } from 'uitk-react-button';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkMenu, UitkMenuContainer, UitkMenuIconTrigger, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { getPathName } from '../../utils/common';
import useAnalytics from '../../hooks/analytics/useAnalytics';

interface SignInButtonProps {
  auth: AuthenticationFragment;
}

interface SignInButtonVariant extends SignInButtonProps {
  onButtonClick: (action: AuthenticationLinkFragment) => void;
}

const SignInButtonMenu: FC<SignInButtonVariant> = ({ auth, onButtonClick }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const buttonsAsMenuItems = auth.buttons.map((button) => ({
    label: button.primary,
    className: 'uitk-list-item',
    onClick: () => onButtonClick(button.action as AuthenticationLinkFragment),
    icon: { name: button.icon?.token },
  }));

  return (
    <UitkMenu isOpen={isOpen} onTriggerClick={() => setIsOpen(!isOpen)}>
      <UitkMenuTrigger>
        <UitkMenuIconTrigger className="custom-trigger-class" icon="account_circle" iconSize={UitkIconSize.MEDIUM} />
      </UitkMenuTrigger>
      <UitkMenuContainer autoPosition>
        <UitkMenuList items={buttonsAsMenuItems} />
      </UitkMenuContainer>
    </UitkMenu>
  );
};

const SignInButtonFlat: FC<SignInButtonVariant> = ({ auth, onButtonClick }) => {
  const authButtons = auth.buttons.map((button) => {
    const authLinkAction = button.action as AuthenticationLinkFragment;
    const Button = button.__typename === 'UISecondaryButton' ? UitkSecondaryButton : UitkPrimaryButton;
    return (
      <Button key={button.primary} data-testid={button.primary} onClick={() => onButtonClick(authLinkAction)}>
        {button.primary}
        {button.icon && <UitkIcon name={button.icon?.token} />}
      </Button>
    );
  });

  return <>{authButtons}</>;
};

const SignInButton: FC<SignInButtonProps> = ({ auth }) => {
  const { trackSignInSelected } = useAnalytics();
  const buttonOnClickHandler = (action: AuthenticationLinkFragment) => {
    trackSignInSelected();
    const target = action.target === 'EXTERNAL' ? '_blank' : '_self';
    const targetPathName = getPathName(action.resource.value);
    const targetURI =
      targetPathName === '/sign-in'
        ? `${targetPathName}?destination=${window.location.pathname}`
        : action.resource.value;
    return window.open(targetURI, target);
  };

  return (
    <Viewport>
      <ViewSmall>
        <SignInButtonMenu auth={auth} onButtonClick={buttonOnClickHandler} />
      </ViewSmall>
      <ViewLarge>
        <SignInButtonFlat auth={auth} onButtonClick={buttonOnClickHandler} />
      </ViewLarge>
    </Viewport>
  );
};

export default SignInButton;
